enum Roles {
    ADMIN = 'admin',
    MANAGER = 'manager',
    TECHNICIAN = 'technician',
}

export const AuthList = [
    {
        email: "admin@neulink.cloud",
        password: "eknKyVN2QsWjBpl4XmA=",
        role: Roles.ADMIN,
    },
    {
        email: "manager@neulink.cloud",
        password: "dNCJADDoarnZ8JAkysM=",
        role: Roles.MANAGER,
    },
    {
        email: "technician@neulink.cloud",
        password: "v5LB0coOWu2WAY6pm/k=",
        role: Roles.TECHNICIAN,
    },
]